import axios from 'axios';

export default {
  boflAuth() {
    return axios.post(`${process.env.VUE_APP_BASE_URL_BOFL}/api/login`,
      {
        email: process.env.VUE_APP_USERNAME_BOFL,
        password: process.env.VUE_APP_PASSWORD_BOFL,
      }, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        console.log(response.data);
        return response.data.token;
      }, (error) => {
        console.log(error);
      });
  },
};
